import React, { useEffect, useState } from "react";
import { Users, Store, Package, FolderTree, ShoppingCart, IndianRupee, Clock } from "lucide-react";
import api from "@/lib/api";
import { LoadingState } from "@/components/common/States";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);

  if (!stats) return <LoadingState />;

  const cards = [
    [Users, "Customers", stats.customers, "bg-blue-50 text-blue-700"],
    [Store, "Vendors", stats.vendors, "bg-emerald-50 text-emerald-700"],
    [Package, "Products", stats.products, "bg-amber-50 text-amber-700"],
    [FolderTree, "Categories", stats.categories, "bg-purple-50 text-purple-700"],
    [ShoppingCart, "Orders", stats.orders, "bg-rose-50 text-rose-700"],
    [Clock, "Pending Approvals", stats.pending_vendor_approvals, "bg-orange-50 text-orange-700"],
  ];

  return (
    <div>
      <h1 className="text-2xl font-serif font-bold text-stone-900 mb-1">Dashboard</h1>
      <p className="text-sm text-stone-500 mb-6">Marketplace overview & platform metrics.</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-stats">
        {cards.map(([Icon, label, value, cls]) => (
          <div key={label} className="rounded-xl border border-border bg-card p-5">
            <div className={`h-10 w-10 rounded-lg grid place-items-center mb-3 ${cls}`}><Icon size={20} /></div>
            <div className="text-2xl font-bold text-stone-900">{value ?? 0}</div>
            <div className="text-sm text-stone-500">{label}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-xl border border-border bg-card p-6">
        <h2 className="font-semibold text-stone-900 mb-2">Modules Roadmap</h2>
        <p className="text-sm text-stone-500 mb-4">Full management for the following activates in later development phases:</p>
        <div className="flex flex-wrap gap-2">
          {["Orders", "Payments", "GST", "Shipping", "Referral", "Wallet", "Commission", "Settlements", "Currency", "Marketing", "Analytics", "Security"].map((m) => (
            <span key={m} className="text-xs font-medium bg-muted text-stone-600 rounded-full px-3 py-1">{m}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
